import {
   Button,
   Dialog,
   DialogActions,
   DialogContent,
   DialogTitle,
   TextField,
} from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import useInput from "../../../../../hooks/useInput";
import useResourceTypes from "../../../../../hooks/useResourceTypes";
import { validators } from "../../../../../utilities/inputValidator";
import Spinner from "../../../../components/spinner/spinner";
import classes from "./AddResourceType.module.css";

const AddResourceType = () => {
   const {
      resourceType: { resourceType, openForm, createLoading },
   } = useSelector((state) => state);

   const { addResourceType, closeResourceTypeForm } = useResourceTypes();

   const {
      value: name,
      valueInputChange: nameInputChange,
      valueIsValid: nameIsValid,
      hasError: nameHasError,
      inputBlurHandler: nameBlurHandler,
   } = useInput(validators.checkValueIsEmpty, `${resourceType.name ?? ""}`);

   const {
      value: description,
      valueInputChange: descriptionInputChange,
      valueIsValid: descriptionIsValid,
      hasError: descriptionHasError,
      inputBlurHandler: descriptionBlurHandler,
   } = useInput(
      validators.checkValueIsEmpty,
      `${resourceType.description ?? ""}`
   );

   const onAddResourceType = () => {
      if (!formIsValid) {
         return;
      }

      const reqBody = {
         name,
         description,
      };

      reqBody.id = resourceType.id && resourceType.id;

      addResourceType(reqBody);
   };

   const formIsValid = nameIsValid && descriptionIsValid;
   return (
      <Dialog
         open={openForm}
         onClose={closeResourceTypeForm}
         onBackdropClick={null}
      >
         <DialogTitle>Devotionals</DialogTitle>
         <DialogContent>
            <TextField
               autoFocus
               margin="dense"
               label="Name"
               type="text"
               fullWidth
               variant="outlined"
               value={name}
               onChange={nameInputChange}
               onBlur={nameBlurHandler}
               error={nameHasError}
            />

            <TextField
               autoFocus
               margin="dense"
               label="Description"
               type="text"
               fullWidth
               variant="outlined"
               value={description}
               onChange={descriptionInputChange}
               onBlur={descriptionBlurHandler}
               error={descriptionHasError}
            />
         </DialogContent>
         <DialogActions>
            <Button onClick={closeResourceTypeForm}>Cancel</Button>
            <Button
               className={classes.button}
               variant="contained"
               onClick={onAddResourceType}
               disabled={!formIsValid}
            >
               Save
            </Button>
         </DialogActions>

         {createLoading && <Spinner />}
      </Dialog>
   );
};

export default AddResourceType;
